import { createFileRoute, Outlet } from "@tanstack/react-router";
import z from "zod";
import { jobQueryOptions } from "@/services/job";

/**
 * Thin Job entity layout — shared params / prefetch for drawer tabs and workspace.
 * Drawer chrome lives in the pathless `_drawer` layout; workspace is a sibling route.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId",
)({
	component: JobIdLayout,
	params: {
		parse: (params) => ({
			jobId: z.string().parse(params.jobId),
		}),
	},
	loader: async ({ context, params }) => {
		await context.queryClient.ensureQueryData(
			jobQueryOptions.detail(params.jobId, {
				organizationId: params.orgId,
			}),
		);
	},
});

function JobIdLayout() {
	return <Outlet />;
}
